/*
 * @Author: ken yang
 * @Date: 2022-08-30 11:14:14
 * @LastEditTime: 2023-09-04 18:17:30
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_admin/src/store/user.js
 */
import { defineStore } from 'pinia'

const useUserStore = defineStore('userStore', {
  state: () => {
    const { token = '', info, } = localStorage
    return {
      token: token ?? '',
      info: isJsonString(info) ? JSON.parse(info) : {},
      user_name: localStorage.user_name || '',
      rowRouters: JSON.parse(localStorage.rowRouters || '[]'),
      menuRouters: [],
      tagList: []
    }
  },
  getters: {
    getMenuRouters: (state) => {
      return state.menuRouters
    },
  },
  actions: {
    async userInfo () {
      const data = await userApi.userInfo({})
      this.info = data
      localStorage.info = JSON.stringify(data)
    },
    logout () {
      localStorage.removeItem('token')
      localStorage.removeItem('info')
      this.$patch(state => {
        state.token = ''
        state.info = {}
      })
      router.push('/login')
    },
    getLanguageList () {
    },
  },
  init () {
    console.log('localStorage.token', localStorage.token)
    if (localStorage.token) {
      console.log('localStorage.token', localStorage.token)
      userApi.userInfo({})
    }
    this.$subscribe((mutation, state) => {
      localStorage.token = state.token
      localStorage.info = JSON.stringify(state.info)
    })
  },
})

export default useUserStore
